import './instrument'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './components/AuthProvider'
import SentryErrorFallback from './components/SentryErrorFallback.jsx'
import { logger } from './utils/logger'

logger.info('LandSentry frontend starting', {
  mode: import.meta.env.MODE,
  log_level: import.meta.env.VITE_LOG_LEVEL || (import.meta.env.DEV ? 'debug' : 'info'),
  sentry_logs_level: import.meta.env.VITE_SENTRY_LOGS_LEVEL || 'info',
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
